import type {Element, Nodes} from 'hast'
import {find, html} from 'property-information'

export function isTag<T extends keyof HTMLElementTagNameMap>(node: Nodes, tagName: T): node is Element & {tagName: T} {
  return node.type === 'element' && node.tagName === tagName
}

/**
 * Convert hast element `properties` object to an object keyed by the HTML attribute name (eg, `class` rather than
 * `className`).
 */
export function hastPropertiesToHtmlAttributes(properties: Element['properties']) {
  if (!properties) return {}

  const result: Record<string, unknown> = {}
  for (const property of Object.getOwnPropertyNames(properties)) {
    const info = find(html, property)
    result[info.attribute] = properties[property]
  }
  return result
}
